export default {
    methods: {
        // Method to determine if a question is scorable
        $_isScorableQuestion(question) {
            return question.questionType !== 2
        },
    }
}